import PropTypes from 'prop-types'
import PageHeader from 'components/PageHeader'
import PageFooter from 'components/PageFooter'
import { Layout, Row, Col } from 'antd'

import styled from 'styled-components'

export const StyledLayout = styled.div`
  height: auto;
  min-height: 100vh;

  .ant-layout {
    background-image: url('/images/bg/signup-bg.png');
    background-size: cover;
    background-attachment: fixed;
  }

  .container {
    min-height: 82vh;
    max-width: 1276px;
    margin: 0 auto;
    background-image: url('/images/bg/signup-bg.png');
    background-size: cover;
    background-attachment: fixed;
  }
  
  .contentWrapper {
    box-shadow: 0 10px 20px 0 rgba(128, 128, 128, 0.2);
    background-color: #F4F4F4;
    border-radius: 20px;
    margin-top: 30px;
    margin-bottom: 76px;
    position: inherit;
  }
`

const { Content } = Layout

export default function Index ({ children }) {
  return (
    <StyledLayout>
      <Layout>
        <PageHeader />
        <Content>
          <Row className='container'>
            <Col span={24} className='contentWrapper'>
              {children()}
            </Col>
          </Row>
        </Content>
        <PageFooter />
      </Layout>
    </StyledLayout>
  )
}

Index.propTypes = {
  children: PropTypes.any
}
